{
  "locale": {
    "de": "German",
    "en": "English"
  },
  "care-next": {
    "title": "Welcome to the new WAKU Care App!",
    "text": "Featuring a new polished design, next to many more tweaks and improvements!",
    "link": "Read more about the changes"
  },
  "validation": {
    "errors": {
      "required": "This field must not be empty",
      "min-length": "Minimum {minLength} characters required",
      "max-length": "Maximum {maxLength} characters allowed",
      "not-smaller-than": "This field must be smaller than {maxValue}",
      "not-greater-than": "This field must be greater than {minValue}",
      "not-smaller-or-equal-than": "This field must be smaller than or equal to {maxValue}",
      "not-greater-or-equal-than": "This field must be greater than or equal to {minValue}",
      "invalid-email": "Invalid email address",
      "invalid-phone": "Invalid phone number (Start with '+' and country code. Without spaces and special characters).",
      "invalid-password": "Invalid password (at least 8 characters and at least one uppercase and one lowercase letter and one number)",
      "pin": "PIN must be exactly 4 digits",
      "passwords-not-equal": "Password does not match",
      "invalid-ip": "Invalid IP addresse",
      "invalid-id": "Invalid ID. Only letters, numbers and hyphens (-) are allowed",
      "invalid-url": "Please enter a valid URL",
      "invalid-number": "Please enter a valid number (e.g. 12.45)",
      "invalid-file-type": "Invalid file type. Allowed file types: {types}",
      "radians": "The radians value must be in the range -Pi and +Pi (-3.14 and +3.14)",
      "already-exists": "{e} already exists.",
      "start-date-before-finish-date": "Start Date must be earlier than Finished Date",
      "min-quantity": "Quantity must be greater than 0",
      "constraint-min-max": "Either minimum or maximum must be set",
      "constraint-disallowed-equal": "Values cannot be equal",
      "unique-name": "Name already used",
      "same-workspace": "Can't be shared with own Workspace"
    }
  },
  "instatus": {
    "status": {
      "UP": "Status OK",
      "HASISSUES": "Issues",
      "UNDERMAINTENANCE": "Maintenance",
      "INVESTIGATING": "Investigating",
      "IDENTIFIED": "Identified",
      "MONITORING": "Monitoring",
      "RESOLVED": "Resolved",
      "OPERATIONAL": "Operational",
      "PARTIALOUTAGE": "Partial Outage",
      "MINOROUTAGE": "Minor Outage",
      "MAJOROUTAGE": "Major Outage",
      "NOTSTARTEDYET": "Not Started Yet",
      "INPROGRESS": "In Progress",
      "COMPLETED": "Completed"
    },
    "type": {
      "maintenance": "System Maintenance",
      "incident": "System Incident"
    },
    "message": {
      "maintenance": {
        "NOTSTARTEDYET": "Due to start at {date} until {end_date}.",
        "INPROGRESS": "Currently in progress until {end_date}",
        "COMPLETED": "Completed since {end_date}."
      },
      "incident": {
        "INVESTIGATING": "Issue is being investigated. (Impact: {impact}).",
        "IDENTIFIED": "Issue cause was identified. (Impact: {impact}).",
        "MONITORING": "Fix was implemented. (Impact: {impact}).",
        "RESOLVED": "Issue resolved. All systems are operational."
      }
    }
  },
  "page-title": {
    "end-of-trial": "End of trial",
    "register": "Start 14-day free trial",
    "register-subtitle": "Enter the world of digital operations and maintenance",
    "login": "Login",
    "login-sso": "Login Company SSO",
    "logout": "Logout",
    "forgot-password": "Request new password",
    "set-password": "Update password",
    "reset-password": "Update password",
    "welcome": "Welcome",
    "account": "Your Account",
    "daily-overview": "Daily overview for {name}",
    "workspaces": "Customer Workspaces",
    "customer-workspace": "Customer: \"{name}\"",
    "workspace-settings": "Settings of \"{name}\"",
    "workspace-device-model-devices": "Devices of \"{name}\"",
    "workspace-device-model-data-triggers": "Device Model Data Triggers of \"{name}\"",
    "workspace-device-data-triggers": "Device Data Triggers of \"{name}\"",
    "deployment-users": "Access Management of",
    "deployment-devices": "Devices",
    "workspace-device": "Device: \"{name}\"",
    "deployment-device": "Device: \"{name}\"",
    "deployment-device-data": "Device Data",
    "deployment-device-error": "Error: \"{title}\"",
    "deployment-device-data-trigger": "Device Data Trigger: \"{title}\"",
    "workspace-deployments": "Deployments of \"{name}\"",
    "workspace-deployment": "Deployment",
    "workspace-knowledge-hub-files": "Knowledge Hub - Files",
    "workspace-knowledge-hub-file": "File: \"{title}\"",
    "workspace-knowledge-hub-case-templates": "Case Templates",
    "workspace-knowledge-hub-checklist-templates": "Work Templates (SOPs)",
    "workspace-checklist-templates": "Work templates from \"{name}\"",
    "workspace-checklist-template": "Work template: \"{title}\"",
    "workspace-case-templates": "Case templates from \"{name}\"",
    "workspace-case-template": "Case template: \"{name}\"",
    "workspace-device-model": "Device Model: \"{name}\"",
    "deployment-maintenance-strategy": "Strategy: \"{title}\"",
    "deployment-maintenance-strategies": "Strategies",
    "workspace-users": "Access Management of \"{name}\"",
    "workspace-user": "User: \"{name}\"",
    "deployment-user": "User: \"{name}\"",
    "deployment-public-portal-settings": "Customer Portal Settings of",
    "deployment-maintenance-device": "Tasks for \"{device}\"",
    "deployment-maintenance": "Work Order: \"{title}\"",
    "deployment-maintenances": "Work Orders",
    "deployment-case": "Case: \"{name}\"",
    "deployment-cases": "Cases",
    "deployment-service-job": "Service Job: \"{name}\"",
    "deployment-service-jobs": "Service Jobs",
    "deployment-inventory-incoming": "Incoming Inventory",
    "deployment-inventory-picking": "Picking",
    "deployment-inventory": "Inventory",
    "deployment-inventory-parts": "Parts",
    "deployment-inventory-activities": "Activities",
    "deployment-inventory-constraints": "Constraints",
    "deployment-part": "Part: \"{name}\"",
    "workspace-custom-inventory": "Custom inventory of \"{name}\"",
    "workspace-parts": "Parts of \"{name}\"",
    "workspace-maintenance-tags": "Work Order Tags of \"{name}\"",
    "workspace-case-tags": "Case Tags of \"{name}\"",
    "workspace-device-tags": "Device Tags of \"{name}\""
  },
  "navigation": {
    "onboarding": "Welcome",
    "account-settings": "Account Settings",
    "help": "Guides & Help",
    "daily-overview": "Daily Overview",
    "workspace": "Workspace",
    "workspace-settings": "Settings",
    "workspace-users": "Users & Permissions",
    "customer-workspaces": "Customer Workspaces",
    "deployments": "Deployments",
    "deployments-overview": "Overview",
    "deployments-settings": "Settings",
    "deployments-customer-portal": "Customer Portal",
    "deployments-users": "Users & Permissions",
    "knowledge-hub": "Knowledge Hub",
    "knowledge-hub-files": "Files",
    "knowledge-hub-checklist-templates": "Work Templates (SOPs)",
    "knowledge-hub-case-templates": "Case Templates",
    "custom-inventory": "Custom Inventory",
    "custom-inventory-devices": "Devices",
    "custom-inventory-parts": "Parts",
    "tags": "Tags",
    "tags-device-tags": "Device Tags",
    "tags-maintenance-tags": "Work Order Tags",
    "tags-case-tags": "Case Tags",
    "service-jobs": "Service Jobs",
    "service-jobs-planner": "Planning",
    "service-jobs-insights": "Insights",
    "cases": "Cases",
    "cases-planner": "Planning",
    "cases-insights": "Insights",
    "maintenances": "Work Orders",
    "maintenances-planner": "Planning",
    "maintenances-insights": "Insights",
    "devices": "Devices",
    "device-data": "Device Data",
    "device-data-errors": "Errors",
    "device-data-missions": "Missions",
    "device-data-charts": "Data Charts",
    "device-data-triggers": "Data Trigger",
    "device-data-availability": "Availability Report",
    "maintenance-strategies": "Strategies",
    "inventory": "Spare Parts",
    "inventory-incoming": "Incoming",
    "inventory-inventory": "Inventory",
    "inventory-assembled": "Assembled",
    "inventory-picking": "Picking",
    "inventory-activities": "Activities",
    "inventory-constraints": "Constraints"
  },
  "404": {
    "title": "Secret place found!",
    "text": "Unfortunately the requested resource doesn't exist and/or was moved to another place. For further questions or feedback, please contact our service team at",
    "button": "Go Back Home"
  },
  "500": {
    "title": "Unexpected Error occurred!",
    "text": "Unfortunately an unexpected error occurred! For further questions or feedback, please contact our service team at",
    "button": "Go Back Home"
  },
  "order": {
    "pending": "pending",
    "started": "started",
    "finished": "successful",
    "aborted": "aborted",
    "cancelled": "cancelled",
    "missing": "missing"
  },
  "open-in-google-maps": "Open in Google Maps",
  "digital-twin": "Digital Twin",
  "data-too-little": "Not enough data to display",
  "account": "Account",
  "workspace": "Workspace",
  "workspaces": "Workspaces",
  "workspace-profile": "Workspace Profile",
  "deployment": "Deployment",
  "deployments": "Deployments",
  "deployment-setting": "Deployment Setting",
  "deployment-settings": "Deployment Settings",
  "deployment-invitation": "Deployment Invitation",
  "public-portal": "Customer Portal",
  "public-portals": "Customer Portals",
  "qr-code": "QR Code",
  "qr-codes": "QR Codes",
  "device": "Device",
  "devices": "Devices",
  "device-log": "Event Log",
  "device-logs": "Event Logs",
  "device-gantt": "Timeline",
  "case-log": "Event Log",
  "case-logs": "Event Logs",
  "maintenance-log": "Event Log",
  "maintenance-logs": "Event Logs",
  "maintenance-strategy-log": "Event Log",
  "maintenance-strategy-logs": "Event Logs",
  "service-job-log": "Service Job Log",
  "service-job-logs": "Service Job Logs",
  "user": "User",
  "users": "Users",
  "role": "Role",
  "workspace-role": "Workspace Role",
  "deployment-role": "Deployment Role",
  "parent-workspace-user": "Role defined in parent workspace",
  "parent-workspace-admin-hint": "This user is an admin in the parent workspace and can't be edited here. If you want to specify a specific role for this deployment, this user needs to be demoted to a viewer in the parent workspace.",
  "parent-workspace-user-hint": "This user is defined in your parent workspace and can't be edited here.",
  "workspace-invitation": "Workspace Invitation",
  "workspace-invitations": "Workspace Invitations",
  "workspace-invited": "Workspace Invited",
  "workspace-parent": "Parent Workspace",
  "workspace-managed": "Managed by another Workspace.",
  "case": "Case",
  "cases": "Cases",
  "service-contract": "Service Contract",
  "service-contracts": "Service Contracts",
  "manufacturer": "Device Manufacturer",
  "manufacturers": "Device Manufacturers",
  "manufactured-at": "Manufacturing Date",
  "device-model": "Device Model",
  "device-models": "Device Models",
  "device-models-relations": "Related Models",
  "device-models-setup-hint": "Setup New Device Models",
  "manufacturers-setup-hint": "Setup New Manufacturers",
  "display": "Display",
  "both": "Both",
  "all-parts": "Parts Inventory",
  "assembled-parts": "Currently Assembled Parts",
  "part-device-select": "Select a Device for assembly",
  "part-device-assemble": "Assemble to",
  "part-locations-not-selected": "You need to select a part location first",
  "part-location-add": "Add part location",
  "part-location-select": "Select parent part location",
  "part-location-template": "Part location template",
  "part-location-templates": "Part location templates",
  "part-location-template-select": "Select part location template",
  "part-location-template-switch": "Create a new root from a selected template",
  "part-location": "Part Location",
  "new-part-location": "New Part Location",
  "parent-part-location": "Parent Part Location",
  "part-quantity-at-part-location": "Quantity {quantity} at part location",
  "part-locations-overview-title": "Manage part locations",
  "part-locations": "Part Locations",
  "part-model-locations-available": "Current Part Model Locations",
  "part-locations-available": "Current Part Locations",
  "part-locations-available-description": "(click to select)",
  "part-locations-selected": "Selected Part Locations",
  "part-locations-source": "Source Location",
  "part-locations-target": "Target Location",
  "part-location-type": "Location Type",
  "part-location-type-inventory": "Inventory",
  "part-location-type-inventory-info": "Use this type for locations where you store spare parts.",
  "part-location-type-incoming": "Incoming",
  "part-location-type-incoming-info": "Use this type if you want to book incoming inventory separately. For example to calculate prices.",
  "part-history": "Part History",
  "part-history-not-found": "History item not found",
  "part-details": "Part Details",
  "part-details-updated": "Part Details Updated",
  "part-manufacturer": "Part Manufacturer",
  "part-manufacturers": "Part Manufacturers",
  "custom-part-manufacturers": "Custom Part Manufacturers",
  "part-category": "Part Category",
  "part-categories": "Part Categories",
  "custom-part-categories": "Custom Part Categories",
  "knowledge-hub": "Knowledge Hub",
  "knowledge-hub-file-relations-empty": "No Device Models linked.",
  "context": "Context",
  "part-model": "Part Model",
  "part-models": "Part Models",
  "part-model-supplier": "Supplier",
  "part-model-supplier-ref": "Supplier Reference",
  "part-model-manufacturer-ref": "Manufacturer Number",
  "part-model-supplier-part-ref": "Supplier Part Number",
  "part-model-order-information": "Order Information",
  "part-model-order-lot-size": "Order Lot Size",
  "part-model-order-min-quantity": "Minimum Order Quantity",
  "custom-part-models": "Custom Part Models",
  "part-model-constraints": "Constraints",
  "part-model-constraint": "Constraint",
  "part-model-constraint-empty": "No Constraints",
  "exceeded": "Exceeded",
  "part-model-constraint-minimum": "Minimum Total Count",
  "part-model-constraint-maximum": "Maximum Total Count",
  "part-model-quantity": "Total Quantity",
  "part-ref": "Serial Number",
  "part-ref-help": "Adding a serial number will make this part a uniquely identifiable single item",
  "part-isolate-toggle": "This part has a serial number",
  "part-isolate-description": "Assigning a serial number to a part will make it a uniquely identifiable single item as soon as you click Save",
  "part-number": "Model Number",
  "part-number-empty": "No Model Number",
  "parts-list-empty": "No Parts added",
  "part-already-exists": "Part already exists in your inventory or in the device",
  "part-no-id": "Parts with multiple items can't have an ID",
  "part-action": "Action",
  "part-action-assembly": "Assembly",
  "part-action-assembly-impossible": "Cannot assemble this part. Use the part from your inventory instead.",
  "part-action-assembly-from-staging": "Assembly from staging",
  "part-action-assembly-from-inventory": "Assembly from inventory",
  "part-action-calibration": "Calibration",
  "part-action-cleaning": "Cleaning",
  "part-action-disassembly": "Disassembly",
  "part-action-disassembly-to-staging": "Disassembly to staging",
  "part-action-disassembly-to-inventory": "Disassembly to inventory",
  "part-action-disassembly-to-trash": "Disassembly to trash",
  "part-action-disassembly-type": "Disassembly Type",
  "part-action-repair": "Repair",
  "part-action-update": "Update",
  "part-action-unspecified": "Unspecified",
  "part-average-price": "Average Price",
  "part-average-price-now": "Current Average Price",
  "part-average-price-new": "New Average Price",
  "part-average-price-per-unit": "per Unit",
  "part-average-price-per-item": "per Item",
  "part-average-price-help": "Enter the average price of the part",
  "part-inventory-search-placeholder": "Note, Model Number, Package Number",
  "part-inventory-booking-details": "Booking Details",
  "maintenance-parts-requested": "Requested Parts",
  "maintenance-parts-allocated": "Allocated Parts",
  "maintenance-parts-left-over": "Left-Over Parts",
  "maintenance-custom-filter-notes": "Has Notes",
  "maintenance-custom-filter-parts-used": "Uses Parts",
  "package-number": "Package Number",
  "package-price": "Package Price",
  "suggestion": "Suggestion",
  "suggestions": "Suggestions",
  "package-price-warning": "This inventory has no package price. If you book it like this, the part will be recorded at a price of 0.",
  "part": "Spare Part",
  "part-placeholder": "Choose from {c} Spare Parts",
  "part-add": "Add Part",
  "parts": "Spare Parts",
  "part-type-single": "Single Part",
  "part-type-multiple": "Multi-Part Item",
  "from-staging": "From Staging",
  "from-inventory": "From Inventory",
  "from-device": "From Device",
  "from-new": "New",
  "inventory": "Parts Inventory",
  "inventories": "Parts Inventories",
  "inventory-create-multiple": "Book {quantity} Part(s)",
  "inventory-create-single": "Book Single Part",
  "inventory-take": "Take inventory",
  "inventory-add": "Add Parts",
  "inventory-add-warning": {
    "title": "Direct additions are recorded at a price of 0 and reported as 0 in the accounting report.",
    "price": "The average price of this part changes from {oldAveragePrice} to {newAveragePrice}.",
    "hint": "Hint: Use the incoming inventory instead."
  },
  "inventory-add-count": "Add {count} Parts",
  "inventory-remove": "Remove Parts",
  "inventory-remove-count": "Remove {count} Parts",
  "inventory-change": "Alter Quantity",
  "inventory-change-count": "Alter Quantity To {count}",
  "inventory-move": "Move Parts",
  "inventory-move-count": "Move {count} Parts",
  "inventory-isolate": "Take out single part",
  "inventory-assembly": "Assembled from Inventory",
  "inventory-assembly-count": "Use {count} Parts from Inventory for Assembly",
  "inventory-disassembly": "Disassembled to Inventory",
  "inventory-disassembly-count": "Disassembled {count} Parts",
  "inventory-empty": "Take an inventory action to add spare parts to your deployments",
  "inventory-history": "Inventory History",
  "inventory-history-quantity": "Stock Level over Time",
  "inventory-history-price": "Average Price over Time",
  "inventory-from": "from",
  "inventory-to": "to",
  "inventory-executed_at-title": "Custom Execution Date",
  "inventory-executed_at-description": "If you want to set a custom execution date, you can do so here. The booking will then be recorded on this date. If you don't set a custom execution date, the current date will be used.",
  "inventory-executed_at-help": "Set a custom execution date",
  "inventory-additional-information": "Additional information",
  "inventory-location-show": "Show part locations",
  "inventory-no-incoming-part-locations": "No incoming part locations found. Please add an incoming part location first.",
  "inventory-incoming-take": "Receipt posting",
  "quantity": "Quantity",
  "no-description": "No Description",
  "set-duration": "Set Duration",
  "service-job": "Service Job",
  "service-jobs": "Service Jobs",
  "maintenance": "Work Order",
  "maintenances": "Work Orders",
  "maintenance-tag": "Work Order Tag",
  "maintenance-tags": "Work Order Tags",
  "case-template": "Case Template",
  "case-templates": "Case Templates",
  "case-tag": "Case Tag",
  "case-tags": "Case Tags",
  "device-tag": "Device Tag",
  "device-tags": "Device Tags",
  "error-title": "Error Title",
  "affected-devices": "Affected Devices",
  "metric": "Metric",
  "device-data-chart": "Device Data Chart",
  "device-data-charts": "Device Data Charts",
  "device-insights-charts": {
    "metric-help": "Only metrics that received data within the last 7 days are listed.",
    "calculate-derivative-help": "Plot the rate of change per second instead of the values themselves.",
    "transform-help": "Plot the transform over a rolling time window instead of the values themselves, e.g. the maximum of the last hour at every point in time. Leave it empty to plot the values as they are.",
    "raw-data": "Raw Data"
  },
  "checklist-template": "Work Template",
  "checklist-templates": "Work Templates",
  "checklist-template-items": "Tasks",
  "checklist-template-item-gallery-help": "You can add images to the task description by uploading them into the gallery below and dragging and dropping them into the editor.",
  "maintenance-strategy": "Strategy",
  "maintenance-strategies": "Strategies",
  "maintenance-strategy-interval": "Strategy Schedule",
  "maintenance-strategy-trigger": "Strategy Trigger",
  "maintenance-strategy-pause": "Pause Strategy",
  "maintenance-strategy-resume": "Resume Strategy",
  "maintenance-approval": "Work Order Approval",
  "maintenance-approvals": "Work Order Approvals",
  "maintenance-approval-file": "Work Order Approval Document",
  "maintenance-approval-files": "Work Order Approval Documents",
  "maintenance-update-single-event": "Update Single Event",
  "maintenance-update-all-events": "Update Work Order Strategy",
  "task": "Task",
  "tasks": "Tasks",
  "comment": "Comment",
  "comments": "Comments",
  "commented": "Commented",
  "follow-up-maintenance": "Follow-up Work Order",
  "follow-up-maintenances": "Follow-up Work Orders",
  "follow-up-task": "Follow-up Task",
  "follow-up-tasks": "Follow-up Tasks",
  "tag": "Tag",
  "tags": "Tags",
  "untagged": "Without Tag",
  "data-connection": "Data Connection",
  "data-connections": "Data Connections",
  "filters-applied": "Filters applied",
  "filters-unapplied": "No Filters applied",
  "filters-reset": "Reset Filters",
  "cancel": "Cancel",
  "create": "Create {e}",
  "create-n": "Create {n} {e}",
  "enable": "Enable {e}",
  "disable": "Disable {e}",
  "filter": "Filter {e}",
  "view": "View {e}",
  "copy": "Copy",
  "copied": "Copied",
  "invite": "Invite",
  "add": "Add",
  "add-to": "Add to",
  "edit": "Edit",
  "save": "Save",
  "saved": "Saved",
  "saved-ago": "Saved ago",
  "back": "Back",
  "next": "Next",
  "page": "Page",
  "next-page": "Next Page",
  "prev-page": "Previous Page",
  "current-page": "Page {page} of {total}",
  "login": "Login",
  "reset": "Reset",
  "apply": "Apply",
  "skip": "Skip",
  "skip-reason": "Skip Reason",
  "auto-skip-by-scheduler": "Skipped automatically by scheduled Strategy",
  "priority": "Priority",
  "priority-level-1": "Lowest Priority",
  "priority-level-2": "Low Priority",
  "priority-level-3": "Medium Priority",
  "priority-level-4": "High Priority",
  "priority-level-5": "Highest Priority",
  "data": "Data",
  "in-use": "In Use",
  "details": "Details",
  "percentage": "Percentage",
  "forgot-password": "Forgot Password",
  "create-new-account": "Create new account",
  "login-with-email": "Login with Email",
  "login-with-sso": "Login with company SSO",
  "system-theme": "System Theme",
  "lightmode": "Light Mode",
  "darkmode": "Dark Mode",
  "automode": "System-Auto Mode",
  "duration": "Duration",
  "duration-in": "in {duration}",
  "duration-ago": "{duration} ago",
  "duration-since": "since {duration}",
  "duration-type": "Duration Source Type",
  "duration-planned": "Planned Duration",
  "duration-resolution": "Resolution Duration",
  "duration-planned-maintenances": "Planned Duration (Work Orders)",
  "duration-resolution-maintenances": "Resolution Duration (Work Orders)",
  "duration-planned-tasks": "Planned Duration (Tasks)",
  "duration-resolution-tasks": "Resolution Duration (Tasks)",
  "duration-planned-maintenances-hint": "Total planned duration of all Work Orders (planned for/until)",
  "duration-resolution-maintenances-hint": "Total resolution duration of all Work Orders",
  "duration-planned-tasks-hint": "Total planned duration of all Tasks",
  "duration-resolution-tasks-hint": "Total resolution duration of all Tasks",
  "duration-planned-followup-maintenances-hint": "Total planned duration of this Work Order and all Follow-up Work Orders",
  "duration-resolution-followup-maintenances-hint": "Total resolution duration of this Work Order and all Follow-up Work Orders",
  "duration-planned-followup-tasks-hint": "Total planned duration of all Follow-up Tasks",
  "duration-resolution-followup-tasks-hint": "Total resolution duration of all Follow-up Tasks",
  "duration-extend": "Extend Duration",
  "expires_in": "Expires in {duration}",
  "content": "Content",
  "content-contained": "Contained Content",
  "use-service-job-dates": "Use Service Job time range",
  "extend": "Extend",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "sunday": "Sunday",
  "hourly": "hourly",
  "hours": "Hours",
  "day": "Day",
  "week": "Week",
  "month": "Month",
  "quarter": "Quarter",
  "daily": "daily",
  "weekly": "weekly",
  "bi-weekly": "biweekly",
  "monthly": "monthly",
  "bi-monthly": "bimonthly",
  "quarterly": "quarterly",
  "semi-annual": "semi-annual",
  "triquarterly": "triquarterly",
  "annual": "annual",
  "biannual": "biannual",
  "ten-minutes": "10 Minutes",
  "thirty-minutes": "30 Minutes",
  "one-hour": "1 Hour",
  "two-hours": "2 Hours",
  "six-hours": "6 Hours",
  "one-day": "1 Day",
  "one-week": "1 Week",
  "one-month": "1 Month",
  "one-year": "1 Year",
  "never": "never",
  "year": "Year",
  "days": "Days",
  "minutes": "Minutes",
  "seconds": "Seconds",
  "detail-level": "Detail Level",
  "service-job-warnings": {
    "duration-planned-exceeded": "The planned duration of Work Orders exceeds the planned duration of the Service Job by:",
    "duration-planned-exceeded-extend": "Extend end date of the Service Job to total planned duration of Work Orders",
    "duration-resolution-exceeded": "The resolution durations of Work Orders & Cases exceed the planned duration of the Service Job by:",
    "duration-resolution-exceeded-extend": "Extend end date of the Service Job to total resolution duration of Work Orders & Cases",
    "missing-duration": "The following Work Orders are missing a Duration / a Planned-Until Date:",
    "outside-timerange-start": "The start date of the following Work Orders are outside of the Service Job time-range:",
    "outside-timerange-end": "The end date of the following Work Orders are outside of the Service Job time-range:",
    "unassigned-maintenances": "The following Work Orders are not assigned to any User:",
    "unassigned-cases": "The following Cases are not assigned to any User:"
  },
  "service-job-primary-reason": "Primary Service Job Task",
  "set-service-job-primary-reason": "Set Primary Service Job Task",
  "set-service-job-maintenances-start": "Apply Service Job Start Date to Work Orders",
  "reported": "Reported",
  "report": "Report",
  "assessed": "Assessed",
  "assess": "Assess",
  "archived": "Archived",
  "archive": "Archive",
  "create-disabled-explanation": "Can't create due to insufficient permissions.",
  "update-disabled-explanation": "Can't update due to insufficient permissions.",
  "accept-disabled-explanation": "Can't accept due to insufficient permissions.",
  "decline-disabled-explanation": "Can't decline due to insufficient permissions.",
  "publish-disabled-explanation": "Can't publish due to insufficient permissions.",
  "reset-disabled-explanation-parts": "Can't reset due to Parts being assigned to this Task.",
  "delete-disabled-explanation": {
    "permission": "Can't delete due to insufficient permissions.",
    "manufacturer": "Can't delete due to Device Models being assigned to this Manufacturer",
    "device-model": "Can't delete due to Devices being assigned to this Device Model",
    "part-manufacturer": "Can't delete due to Part Models being assigned to this Part Manufacturer",
    "part-category": "Can't delete due to Part Models being assigned to this Part Category",
    "part-model": "Can't delete due to Parts being assigned to this Part Model",
    "deployment": "Can't delete due to Devices being assigned to this Deployment",
    "maintenance": "Can't delete due to Work Order already started",
    "maintenance-virtual": "Strategy has to be changed, to delete this Work Order",
    "maintenance-device": "Can't delete due to Work Order on Device already started",
    "maintenance-item": "Can't delete due to Task already started",
    "checklist-template": "Can't delete due to Work Template being shared or public.",
    "part-location-quantity": "Can't delete due to part location still having items in it"
  },
  "disabled-maintenance-started-finished": "Work Order not started or already completed",
  "disabled-maintenance-started": "Work Order already started",
  "disabled-maintenance-finished": "Work Order already completed",
  "disabled-tasks-started-finished": "Tasks already started/completed",
  "disabled-tasks-started": "Tasks already started",
  "disabled-tasks-finished": "Tasks already completed",
  "cases-created-resolved": "Cases created / resolved",
  "case-to-maintenance": "Case to Work-Order Connection",
  "cases-to-maintenances": "Case to Work-Order Connections",
  "maintenance-to-maintenance": "Work-Order Connection",
  "maintenances-to-maintenances": "Work-Order Connections",
  "case-to-service-job": "Case to Service Job Connection",
  "cases-to-service-jobs": "Case to Service Job Connections",
  "maintenance-to-service-job": "Work Order to Service Job Connection",
  "maintenances-to-service-jobs": "Work Order to Service Job Connections",
  "user-to-service-job": "Assignee to Service Job Connection",
  "users-to-service-jobs": "Assignee to Service Job Connections",
  "by": "By {e}",
  "belongs-to": "Belongs to",
  "resolution-time": "Resolution Time",
  "average": "Average",
  "minimum": "Minimum",
  "maximum": "Maximum",
  "owner": "Owner",
  "daily-overview-catchup": {
    "title": "Catchup Tasks",
    "description": "Work Orders & Service Jobs not yet completed"
  },
  "daily-overview-today": {
    "title": "Today's Tasks",
    "description": "Cases, Work Orders & Service Jobs scheduled for today"
  },
  "daily-overview-next": {
    "title": "Upcoming Tasks",
    "description": "Unresolved Cases, upcoming Work Orders & Service Jobs"
  },
  "coming-soon": "Available Soon...",
  "assignee": "Assignee",
  "assignees": "Assignees",
  "responsible": "Responsible",
  "assign-me": "Assign me",
  "assign-to-all": "Assign to all",
  "assign-to-all-cases": "Assign to all Cases",
  "assign-to-all-cases-without-assignee": "Assign to all Cases without Assignee",
  "assign-to-all-maintenances": "Assign to all Work Orders",
  "assign-to-all-maintenances-without-assignee": "Assign to all Work Orders without Assignee",
  "default-responsible": "Responsible by default",
  "default-responsible-hint": "If no Assignee is set, this User be responsible by default",
  "default-responsible-setup": "Setup Default Assignee",
  "default-notification-email": "Default Notification Email",
  "default-notification-email-hint": "A notification email will be send, if a new unit is created",
  "device-data-settings": "Device Data Settings",
  "device-data-shift": "Shift",
  "device-data-shift-hint": "Device analytics are calculated based on the shift. If an event occurs outside of the shift it is ignored. If a part of an event overlaps with the shift, only overlapping part is considered.",
  "device-data-error-duration": "Downtime",
  "device-data-error-severity": "Exclude Errors by Severity",
  "device-data-error-severity-hint": "Errors with a severity below this threshold are excluded from the analytics.",
  "device-data-error-titles": "Exclude Errors by Title",
  "device-data-error-titles-hint": "Errors with a title matching any of the following titles are excluded from the analytics. Note, only exact matches are considered.",
  "device-data-error-title-new": "New Title",
  "device-data-error-title-preview": "Preview",
  "maintenance-insights-charts": {
    "finished-aggregated": {
      "title": "Finished Work Order Counts",
      "subtitle": "Aggregated Work Orders by Deployments, Users etc., grouped by Work Order Tags"
    },
    "finished-resolve-time": {
      "title": "Finished Work Orders Resolution Time",
      "subtitle": "Time to resolution (minimum, maximum, average) of finished Work Orders",
      "duration-hint": "Choose resolution duration from either Work Order (includes total duration of all Device Tasks) or from invidiual Device Tasks (which are only tracked if Tasks are started and finished)."
    },
    "finished-device-utilization": {
      "title": "Device Utilization in Finished Work Orders",
      "subtitle": "Percentage of maintained Devices in finished Work Orders"
    },
    "by-status-tag-period": {
      "title": "Work Orders Over Time",
      "subtitle": "Work Orders by Status, grouped by Work Order Tags, per period"
    }
  },
  "service-job-insights-charts": {
    "by-maintenance-tag": {
      "title": "Service Jobs by Work Order Tag (Primary Reason)",
      "subtitle": "Which Work Order Tags were the reason for the most Service Jobs"
    },
    "by-case-tag": {
      "title": "Service Jobs by Case Tag (Primary Reason)",
      "subtitle": "Which Case Tags were the reason for the most Service Jobs"
    },
    "maintenances-distribution": {
      "title": "Work Orders per Service Job",
      "subtitle": "Distribution of how many Work Orders are linked to each Service Job (avg, min, max)"
    },
    "cases-distribution": {
      "title": "Cases per Service Job",
      "subtitle": "Distribution of how many Cases are linked to each Service Job (avg, min, max)"
    }
  },
  "next-date": "Next date",
  "next-device": "Next device",
  "next-maintenance": "Next Work Order",
  "interval": "Interval",
  "no-interval": "No Interval",
  "trigger": "Trigger",
  "no-trigger": "No Trigger",
  "interval-divergating": {
    "title": "Strategy interval is divergating from last Work Order date",
    "text": "update the strategy interval",
    "description": "The following manually planned Work Orders are NOT automatically rescheduled. Therefore you have to reschedule, delete or otherwise handle them yourself.",
    "change": "strategy interval update"
  },
  "before": "Before",
  "after": "After",
  "creator": "Creator",
  "users-of-e-in-x": "Users of \"{e}\" in \"{x}\"",
  "users-external-workspace": "Users outside your Workspace",
  "workspace-hide-public-materials": "Hide public materials in Workspace (eg. Work Templates, Manufacturers, Device Models)",
  "userlocale": "User language",
  "locale-only": "Language",
  "locale-hint": "The language the recipient will receive this email in.",
  "date": "Date",
  "active": "Active",
  "paused": "Paused",
  "id": "ID",
  "count": "Count",
  "name": "Name",
  "entity-name": "{e} Name",
  "title": "Title",
  "description": "Description",
  "abbreviation": "Abbreviation",
  "website": "Website",
  "repairs": "Repairs",
  "additional-settings": "Additional Settings",
  "additional-filters": "Additional Filters",
  "settings": "Settings",
  "calendar": "Calendar",
  "table": "Table",
  "treeview": "Treeview",
  "grid": "Grid",
  "kanban": "Kanban",
  "use-x": "Use {e}",
  "select-x": "Select {e}",
  "x-selected": "{e} selected",
  "select-all": "Select All",
  "deselect-all": "Deselect All",
  "select-all-unsafe": "Too many items selectable! Use search to narrow down search results in order to select all items.",
  "ordering-up": "Move up",
  "ordering-down": "Move down",
  "part-model-category-select": "Select Part / Model / Category",
  "count-entity-selected": "{c} {e} selected",
  "deployments-select": "{c} Deployments selected",
  "deployment-workspace": "Deployment (Workspace)",
  "customer-deployments-overview": {
    "title": "Deployments from Customer Workspaces",
    "deployment-inaccessible": "You currently can't access this Deployments information, because you aren't an active User in this Deployment. To access all the Deployments information, add yourself / be added to this Deployment first.",
    "deployment-inaccessible-short": "As an inactive Deployment-User you currently can't access this Deployments information."
  },
  "deployment-sharing": {
    "title": "Pending Invitations",
    "subtitle": "Waiting to be accepted or declined by receiving Workspace",
    "empty": "Congratulations, there are no pending sharing invitations for this deployment"
  },
  "workspace-invitations-overview": {
    "title": "Pending Invitations",
    "subtitle": "Waiting to be accepted or declined by receiving user",
    "empty": "Congratulations, there are no pending user invitations for this workspace"
  },
  "created": "Created",
  "resolved": "Resolved",
  "resolve": "Resolve",
  "total": "Total",
  "at": "on",
  "created-at": "Created on",
  "updated-at": "Updated on",
  "executed-at": "Executed on",
  "finished-from": "Finished from",
  "shared-at": "Shared on",
  "shared-with": "Shared with",
  "maintenance-for": "for",
  "maintenance-until": "until",
  "maintenance-duration": "duration",
  "not-set": "not set",
  "planned-for": "Planned for",
  "planned-until": "Planned until",
  "planned-duration": "Planned duration",
  "expected-until": "Expected until",
  "until": "until",
  "started-at": "Started on",
  "expected-resolved-at": "Expected resolved on",
  "resolved-at": "Finished on",
  "archived-at": "Archived on",
  "reported-at": "Reported on",
  "assessed-at": "Assessed on",
  "due-at": "Due on",
  "due-in": "Due in",
  "edited-at": "Edited on",
  "reschedule-event": "Reschedule Event",
  "rescheduled-event": "Rescheduled Event",
  "overview": "Overview",
  "actions": "Actions",
  "fast-actions": "Fast Actions",
  "location": "Location",
  "address": "Address",
  "address-1": "Address 1",
  "address-2": "Address 2",
  "city": "City",
  "country": "Country",
  "zipcode": "Postal code",
  "csv-export-part-inventories": "Export Part Inventory (CSV)",
  "csv-export-part-inventories-help": "Export the Part Inventory of a Deployment",
  "csv-export-fifo-part-inventories": "Export FIFO Part Inventory (CSV)",
  "csv-export-fifo-part-inventories-help": "Uses FIFO accounting to export the Part Inventory of a Deployment",
  "csv-export-part-inventories-with-constraints": "Export Part Inventory With Constraints (CSV)",
  "csv-export-part-inventories-with-constraints-help": "Export the Part Inventory of a Deployment within a given timeframe",
  "csv-export-part-inventories-international": "Non-european users should activate both options, to be able to import the CSV file to Excel/Numbers correctly.",
  "csv-export-part-inventories-format-delimiter": "Use comma as CSV row delimiter",
  "csv-export-part-inventories-format-numbers": "Use dot as decimal number separator (eg. '10,000.23')",
  "csv-export-cases": "Export Cases (CSV)",
  "csv-export-maintenances": {
    "title": "Export Work Orders (CSV)",
    "subtitle": "Content of CSV Export",
    "maintenances": "Work Orders",
    "maintenance-items": "Work Order Tasks",
    "maintenance-items-without-device-logs": "Work Order Tasks & Device Logs"
  },
  "drag-to-sort": "Drag to sort",
  "sort-by": "Sort By",
  "aggregate-by": "Aggregate By",
  "permissions": "Permissions",
  "admin": "Admin",
  "technician": "Technician",
  "end_customer": "End-Customer",
  "viewer": "Read-Only",
  "associate": "Deployment-Specific-Access",
  "none": "None",
  "scope": "Scope",
  "invitee": "Invitee",
  "app-offline-ready": "App offline ready",
  "role-explanation": {
    "workspace": {
      "admin": "Read & Update everything in Workspace",
      "viewer": "Read everything in the Workspace",
      "associate": "Read & Update everything in assigned Deployment",
      "none": "No rights"
    },
    "deployment": {
      "admin": "Read & Update everything in Workspace",
      "viewer": "Read everything in the Workspace",
      "end_customer": "Read everything in Workspace, can create Cases",
      "technician": "Read everything in Workspace, can create Cases, Work Orders and maintain Device Parts",
      "none": "No rights"
    }
  },
  "start-task": "Start",
  "start-timer": "Start Timer",
  "work-log": "Work Log",
  "instructions": "Instructions",
  "contact-information": "Contact Information",
  "notes": "Notes",
  "all-notes": "All notes",
  "notes-from-maintenances": "Notes from maintenances",
  "documentation": "Documentation",
  "media-files": "Pictures, Videos & Files",
  "media-files-empty": "No Pictures, Videos or Files provided",
  "start-maintenance": "Start Work Order",
  "finish-maintenance": "Complete Work Order",
  "finish-maintenance-all-tasks-done": "All Tasks are completed",
  "finish-maintenance-still-tasks-open": "There are unresolved Tasks todo",
  "reason": "Reason",
  "invites": "invitations",
  "timeline": "Timeline",
  "gantt": "Planner",
  "controls": "Controls",
  "gantt-controls-help": {
    "shift-key": "shift",
    "scroll-key": "scroll",
    "to-zoom": "to zoom",
    "drag-key": "drag",
    "drag-to-move": "chart to move around",
    "hold-key": "hold",
    "hold-to-move": "item to move",
    "hold-edge-to-resize": "item edge to reschedule"
  },
  "now": "Now",
  "waku-device-id": "WAKU Device ID",
  "device-ref-id": "Device Reference ID",
  "document": "Document",
  "documents": "Files & Documents",
  "images-and-videos": "Pictures & Videos",
  "file": "File",
  "files": "Files",
  "file-pdf": "PDF File",
  "upload": "Upload {e}",
  "download": "Download {e}",
  "download-as": "Download {e} as",
  "template": "Template",
  "file-upload": "Upload file",
  "file-upload-image": "Upload picture",
  "file-upload-image-video": "Upload picture/video",
  "custom-file-upload": "Custom File Upload",
  "zoom-fit-to-page": "Fit to page",
  "zoom-fit-to-width": "Fit to width",
  "zoom-out": "Zoom Out",
  "zoom-in": "Zoom In",
  "rotate-left": "Rotate Left",
  "rotate-right": "Rotate Right",
  "fullscreen": "Fullscreen",
  "fullscreen-exit": "Exit Fullscreen",
  "column-show": "Show Column",
  "column-hide": "Hide Column",
  "column-width": "Column Width",
  "profile-image": "Profile Image",
  "service-and-repairs": "Work Orders and Repairs",
  "servicing-history": "Work Order History",
  "complete-history": "Complete history",
  "history": "History",
  "logbook": "Logbook",
  "done-and-skipped": "Completed & Omitted",
  "manufacturer-serial": "Serial Number",
  "upcoming": "Upcoming",
  "today": "Today",
  "yesterday": "Yesterday",
  "tomorrow": "Tomorrow",
  "ongoing": "Started",
  "due-today": "Due today",
  "due": "Overdue",
  "original-plan": "Original Plan",
  "plan": "Plan",
  "scheduled": "Planned",
  "execution": "Execution",
  "pending": "Planned",
  "started": "Started",
  "finished": "Completed",
  "completed": "Completed",
  "failed": "Failed",
  "skipped": "Skipped",
  "skip-all": "Skip all",
  "complete-all": "Complete all",
  "fail-all": "Fail all",
  "skip-remaining-tasks": "Skip remaining open tasks",
  "follow-up-operations": "Follow-up Operations",
  "linked-operations": "Linked Operations",
  "linked-cases": "Linked Cases",
  "linked-maintenances": "Linked Work Orders",
  "linked-service-jobs": "Linked Service Jobs",
  "unlink-maintenance": "Remove connection to Work Order",
  "unlink-case": "Remove connection to Case",
  "unlink-service-job": "Remove connection to Service Job",
  "maintenances-history": {
    "title": "History",
    "subtitle": "Completed & Skipped Work Orders"
  },
  "maintenances-open": {
    "title": "Open",
    "subtitle": "Open & Due Work Orders"
  },
  "maintenances-upcoming": {
    "title": "Upcoming",
    "subtitle": "Planned Work Orders"
  },
  "maintenances-created-resolved": "Work Orders created / resolved",
  "maintenances-due": "Overdue Work Orders",
  "maintenances-outlook": "Upcoming Work Orders",
  "maintenances-today": "Today's Work Orders",
  "maintenances-started": "Started Work Orders",
  "maintenance-approval-print": "Please review the content of the generated approval document. To approve the Work Order, go to the next step and either directly upload this document or upload any other document.",
  "maintenance-approval-download": "Download the previously generated Work Order Approval Document, to print it, share it with customers or colleagues.",
  "maintenance-approval-upload": "Directly upload the previously generated Work Order Approval Document, without customizing it.",
  "maintenance-approval-upload-custom": "Upload a custom Work Order Approval Document, with custom signatures, content or remarks.",
  "maintenance-create-bulk": {
    "title": "Bulk-Add Work Orders",
    "filter-title": "Filter Devices for which Work Orders are to be created",
    "mass-assign": "Fast-assign information to all Work Orders to be created",
    "hint-title": "Custom Work Order prefix to Device name, eg.'Maintenance' -> 'Maintenance (MyDeviceName)'",
    "hint-checklist-template": "Share Work Templates with Workspaces of Deployments, wherein Work Orders shall be created, to ensure visiblity.",
    "hint-assignee": "Invite Users to Deployments to be able to assign them to Work Orders to be created.",
    "hidden-other-deployment": "{n} Work Orders of other Deployments are not shown, because they can't be linked to a Service Job of {e}"
  },
  "device-details": "Device Details",
  "device-details-updated": "Device Details Updated",
  "no-tasks": "There is nothing for you to do today",
  "strategy-utilization": "General Strategy Utilization",
  "schedule-utilization": "Schedule Strategy Utilization",
  "anomaly-utilization": "Anomaly Strategy Utilization",
  "usage-utilization": "Usage Strategy Utilization",
  "usage-in-strategies": "Usage in Strategies",
  "usage-in-maintenances": "Usage in Work Orders",
  "cases-percentage-devices": "Devices afflicted in Cases",
  "maintenances-percentage-devices": "Maintained Devices",
  "unassigned": "Unassigned",
  "setup-chip": "Setup",
  "setup-create-first-deployment": "Add your first deployment",
  "setup-create-first-device": "Add your first Device",
  "pin": "PIN",
  "public-id-virtual-hint": "This elements state is forecasted, thus receives its official ID after creation.",
  "case-create-maintenance-from-template": "Create Work Orders from proposed Work Templates",
  "origin": "Origin",
  "case-template-source-case": "Created via Case Template",
  "public-portal-source-case": "Created via Customer Portal Request",
  "device-data-trigger-source-case": "Created via Device Data Trigger",
  "case-comment-public-for-portal": "Display Comment in Customer Portal",
  "public-portal-access-hint": "Use the previously received PIN to access the Customer Portal for the scanned Device.",
  "public-portal-access-invalid": "Customer Portal Access invalid",
  "public-portal-request": "Request",
  "public-portal-last-requests": "Last Requests",
  "public-portal-last-requests-hint": "Check if your request topic has already been filed",
  "public-portal-request-title": "File a request for {device}",
  "public-portal-request-title-deployment": "File a request for {deployment}",
  "public-portal-request-device-hint": "Optionally select the device your request is about",
  "public-portal-request-device-placeholder": "Select a device (optional)",
  "public-portal-settings-no-pin-warning": "This Customer Portal has no PIN. Anyone with the QR code or its link can file requests{cases}. Set a PIN to restrict access.",
  "public-portal-settings-no-pin-warning-cases": " and read open Cases",
  "public-portal-settings-pin-optional": "Leave empty for no PIN. Without a PIN, anyone with the QR code can access this Customer Portal.",
  "public-portal-settings-deployment-qr-code": "Deployment QR Code",
  "public-portal-settings-deployment-qr-code-hint": "A QR code for the whole Deployment, for requests that are not about one specific Device.",
  "public-portal-request-template-hint": "Select from predefined often filed requests",
  "public-portal-request-name-hint": "Describe your request in a few words",
  "public-portal-request-name-hint-example": "eg. device is offline",
  "public-portal-request-description-hint": "Provide any detail, that's helpful in solving the request.",
  "public-portal-request-description-hint-example": "eg. the device is not working as expected, because ...",
  "public-portal-request-contact": "Your Contact Information (optional)",
  "public-portal-request-contact-hint": "Provide your contact information, for update notifications or in case of questions.",
  "public-portal-request-sent": "Request sent successfully!",
  "public-portal-request-reset": "Make another Request",
  "public-portal-settings-enable-portal": "Enable the Customer Portal for this Deployment, to publicly receive service requests for Devices in this Deployment",
  "public-portal-settings-visit": "View and edit this Deployments Customer Portal settings",
  "public-portal-settings-go-to": "Go to Customer Portal settings",
  "public-portal-settings-pin-create": "Set a 4-digit PIN to enable the Customer Portal for this Deployment. This PIN is requested for every Customer Portal Request. Only share this PIN with trustworthy users to prevent abuse. You can change this PIN later.",
  "public-portal-settings-show-open-cases": "Enable to display recent open Cases in Customer Portal",
  "public-portal-settings-show-device-selector": "Enable to let reporters select a Device in Deployment Customer Portal Requests",
  "public-portal-settings-show-device-selector-hint": "Only applies to the Deployment QR Code. When enabled, the Devices of this Deployment are listed in the Customer Portal.",
  "public-portal-settings-show-workspace-profile-logo": "Enable to display the Workspace logo at the top of the Customer Portal",
  "public-portal-settings-show-workspace-profile-logo-hint": "Requires a logo to be uploaded in the Workspace Settings. Without one, the app logo is shown instead.",
  "public-portal-settings-show-workspace-profile-logo-missing": "No Workspace logo is set yet. Upload one in the Workspace Settings to enable this option.",
  "public-portal-settings-welcome-message": "Welcome Message",
  "public-portal-settings-intro": "Welcome Message will be displayed for every Customer Portal Request (eg. general information about the application)",
  "public-portal-settings-instructions": "Instructions will be displayed for every Customer Portal Request (eg. reporting guidelines)",
  "public-portal-settings-contact-information": "Contact Information will be displayed for every Customer Portal Request (eg. phone or email)",
  "case-template-setup": "Setup Case Templates",
  "case-template-name": "Title (short problem summary)",
  "case-template-name-hint": "Will be used as the title (short problem summary) for the Case",
  "case-template-description": "Description",
  "case-template-description-hint": "Will be used as the problem description for the Case",
  "case-template-proposal": "Solution Proposal",
  "case-template-proposal-hint": "Will be used as the solution proposal for the Case",
  "case-template-solution": "Solution Statement",
  "case-template-solution-hint": "Will be used as the solution statement for the Case",
  "case-template-type": "Case Type",
  "case-template-type-hint": "Will be used as the type for the Case",
  "case-template-public-portals": "Customer Portals",
  "case-template-public-portals-hint": "Make this Case Template available to the Customer Portals of the selected Deployments",
  "case-template-checklist-templates": "Work Templates (SOPs)",
  "case-template-checklist-templates-hint": "Propose these Work Templates as Solution Proposal in Cases created with this Case Template",
  "case-templates-public-portal-hint": "Make these Case Templates available to the Customer Portal",
  "pdf-include-logo": "Include logo",
  "pdf-include-label": "Include Device name",
  "pdf-include-appUrl": "Include QR-Code URL",
  "pdf-page-format": "Document format",
  "pdf-page-orientation": "Document orientation",
  "pdf-margin-size-mm": "Document margin size (in mm)",
  "pdf-qr-code-size-mm": "QR-Code size (in mm)",
  "text": "Text",
  "insights": "Insights",
  "in-open": "In open {e}",
  "in-pending": "In pending {e}",
  "not-available": "N/A",
  "access": "With Access",
  "no-access": "No Access",
  "not-accessible": "{e} Not Accessible",
  "no-access-explanation": {
    "general": "You don't have access to this {e}, because it may have been moved, deleted or you lost access rights to it.",
    "in-use": "You either don't have access to this {e}, or it is still used by other entities.",
    "workspace-user": "The user \"{e}\" doesn't have access to the Workspace \"{w}\".",
    "workspace-user-associate": "The user \"{e}\" doesn't have access to the Workspace \"{w}\" itself, but (limited) access to a shared Deployment of this Workspace."
  },
  "resources": "Resources",
  "online": "Online",
  "offline": "Offline",
  "live": "Live",
  "no-connection": "No Data Connection",
  "no-connection-explanation": "No WAKU Data Connector for machine data integration configured. Contact Customer Success Team to buy and configure the WAKU Data Connector.",
  "optional": "Optional",
  "operational-data": "Operational Data",
  "operational-data-info": "Showing operational data up to 1 hour prior to this event",
  "operational-data-device-utilization": "Device Utilization",
  "operational-data-errors-warnings": "Errors & Warnings",
  "operational-data-missions": "Missions",
  "device-data": {
    "title": "Device Data",
    "azimuth": "Yaw Drive Activity",
    "rpm": "RPM",
    "solarenergy": "Solar Energy",
    "windenergy": "Wind Energy",
    "solarpower": "Solar Power",
    "windpower": "Wind Power",
    "windspeed": "Wind Speed",
    "winddirection": "Wind Direction",
    "windpower_solarpower_combined": "Wind Power & Solar Power",
    "windenergy_solarenergy_combined": "Wind Energy & Solar Energy"
  },
  "device-model-data-trigger": "Device Model Data Trigger",
  "device-model-data-triggers": {
    "entity": "Device Model Data Triggers",
    "apply-to-deployment": "Apply to specific Deployment",
    "auto-offset": "Auto-Offset",
    "auto-offset-description": "When enabled, the offset is set automatically to the last reading of each applicable device. When disabled, the offset is initiallized to 0.",
    "delete-description": "Deleting a device model data trigger will convert the included device data triggers to regular device data triggers."
  },
  "device-data-trigger": "Device Data Trigger",
  "device-data-triggers": {
    "entity": "Device Data Triggers",
    "entity-managed": "Managed Device Data Triggers",
    "entity-managed-description": "These Triggers are managed by this Device Model Data Trigger",
    "presets": {
      "title": "Choose a preset",
      "peak": "Peak",
      "peak-description": "Sudden spike within a short time window",
      "peak-description-extended": "The trigger fires when the maximum value of the metric within the last hour exceeds a threshold value. Set the threshold value to the value that needs the trigger to fire.",
      "trend": "Trend",
      "trend-description": "Slow drift, overheating, mid- to long-term issues",
      "trend-description-extended": "The trigger fires when the average value of the metric within the last hour exceeds a threshold value. Set the threshold value to the value that needs the trigger to fire.",
      "usage": "Usage-Based",
      "usage-description": "The trigger fires every time a metric crosses a threshold-multiple (e.g. every 1000 units).",
      "usage-description-extended": "The trigger fires everytime the value of the metric exceeds a multiple of the threshold value. Set the threshold value to the value that needs the trigger to fire.",
      "deviation": "Deviation",
      "deviation-description": "The trigger fires when the rate of change of a metric exceeds a threshold.",
      "deviation-description-extended": "The trigger fires when the maximum rate of change of the metric within the last hour exceeds a threshold value. Set the threshold value to the value that needs the trigger to fire.",
      "threshold-zone": "Threshold Zone",
      "threshold-zone-description": "The trigger fires when the last value of a metric goes above/below a threshold.",
      "threshold-zone-description-extended": "The trigger fires when the last value of the metric within the last hour goes above/below a threshold value. Set the threshold value to the value that needs the trigger to fire.",
      "dynamic": "Dynamic",
      "dynamic-description": "The trigger fires based on statistical properties of the metric data.",
      "dynamic-description-extended": "The trigger fires when the value of the metric is more than 2 standard deviations away from the mean (calculated over the selected window).",
      "custom": "Custom",
      "custom-description": "Create a custom trigger based on a custom expression.",
      "custom-description-extended": "Create a custom trigger based on a custom expression."
    },
    "evaluation-frequency": {
      "title": "Evaluation Frequency",
      "frequent": "Every 5 minutes",
      "every-hour": "Every hour",
      "every-6-hours": "Every 6 hours",
      "daily": "Daily"
    },
    "time-window": {
      "title": "Evaluation Time Window",
      "max-age-title": "Maximum Data Age",
      "small": "5 minutes",
      "medium": "1 hour",
      "long": "6 hours",
      "day": "24 hours",
      "all": "All data so far"
    },
    "promote-to-device-model-data-trigger": "Apply this trigger to all devices of this device model",
    "target-table": "Data Source",
    "target-table-help": "The kind of device data this trigger evaluates.",
    "target-table-device_scalar_values": "Scalar Values",
    "target-table-device_scalar_values-help": "Numeric sensor readings, e.g. temperature or battery level.",
    "target-table-device_errors": "Errors",
    "target-table-device_errors-help": "Count of device error events.",
    "target-table-device_orders": "Orders",
    "target-table-device_orders-help": "Count of device missions/orders.",
    "action": "Action",
    "action-description": "Action to take when the trigger is fired. Default is to create a case.",
    "details": "Trigger Details",
    "evaluation": "Trigger Evaluation",
    "paused": "Trigger is Paused",
    "pause": "Pause Trigger",
    "resume": "Resume Trigger",
    "force-run": "Evaluate Trigger Now",
    "status": "Status",
    "ok": "Ok",
    "firing": "Firing",
    "firing-since": "Firing Since",
    "open-cases": "Open Cases",
    "open-maintenances": "Open Work Orders",
    "derivative": "Derivative",
    "name": "Name",
    "chart": "Chart",
    "calculate-derivative": "Calculate Derivative",
    "calculate-derivative-help": "Calculate the derivative of the metric data before evaluating the trigger. This can be useful to detect changes in the metric data.",
    "expression": "Expression",
    "transform": "Transform",
    "transform-help": "Transform the metric data before evaluating the trigger. This can be useful to normalize or aggregate the data. You can leave the transform empty to use the raw data.",
    "operator": "Operator",
    "operator-help": "Operator to use for comparing the threshold to the metric data.",
    "threshold": "Threshold",
    "threshold-help": "Threshold to compare the metric data to.",
    "threshold-source": "Threshold Source",
    "threshold-source-help": "Source of the threshold value. Default is a fixed threshold.",
    "threshold-source-fixed": "Fixed Threshold",
    "threshold-source-fixed-help": "A fixed thershold value is used to compare the metric data to.",
    "threshold-source-step": "Step Threshold",
    "threshold-source-step-help": "The threshold will be triggered on every multiple of the threshold value.",
    "threshold-source-step-display": "every",
    "threshold-source-two_sigma": "2-Sigma",
    "threshold-source-two_sigma-help": "The threshold will be triggered if the metric data is more than 2 standard deviations away from the mean.",
    "new-offset-value": "New Offset Value",
    "new-offset-value-description": "Based on the current reading of \"{e}\"",
    "current-offset-value": "Current Offset Value",
    "offset-value": "Offset Value",
    "offset-value-help": "Offset trigger computation by a sepcific value. Default is 0.",
    "offset-value-no-value": "No Offset Value",
    "update-offset-value": "Update Offset Value",
    "last-value": "Last Value",
    "last-value-no-value": "not received yet",
    "progress": "Progress",
    "remaining": "Remaining until trigger fires",
    "last-run-at": "Last Run At",
    "next-fire-value": "Trigger will fire at",
    "configuration": "Trigger Configuration",
    "managing": "Managing Trigger",
    "managing-description": "This trigger is used as a template for all devices of this device model. Changes will be applied to all devices of this device model.",
    "managed": "Managed Trigger",
    "managed-description": "This trigger is managed by a device model. Changes will be overwritten when the model trigger is updated.",
    "trigger-count": "Trigger Status Count",
    "trigger-count-total": "Triggers Total",
    "trigger-count-firing": "Triggers Firing",
    "preview": {
      "title": "Recent Counts",
      "current-count": "{count} in current window",
      "total-count": "{count} total"
    }
  },
  "incident-report": "Incident Report",
  "full-report": "full report",
  "install-sense": "Install WAKU Sense for live Device data and more!",
  "request-offer": "Request a quote",
  "manage": "Manage {e}",
  "managed-by": "Managed by",
  "created-by": "Created by",
  "logged-in-as": "Logged in as",
  "account-settings": "Account Settings",
  "custom-inventory": "Custom Inventory",
  "custom-tasks": "Custom Tasks",
  "logout": "Log out",
  "logout-text": "You are now being redirected",
  "system-status": "System Status",
  "threshold": "Threshold",
  "every": "every",
  "current-progress": "Current Progress",
  "preview": "{e} Preview",
  "print": "Print {e}",
  "type": "Type",
  "case-type": "Case Type",
  "case-types": "Case Types",
  "anomaly": "Anomaly",
  "accident": "Accident",
  "damage": "Damage",
  "improvement": "Improvement",
  "usage": "Usage",
  "schedule": "Schedule",
  "period": "Period",
  "device-usage": "Device usage",
  "danger-zone": "Danger Zone",
  "number-of-errors": "Number of errors",
  "error": "Error",
  "errors": "Errors",
  "warning": "Warning",
  "warnings": "Warnings",
  "availability": "Availability",
  "overall-availability": "Overall Availability",
  "no-device-tag": "No Device Tags selected",
  "no-device-tag-explanation": "Please select at least one Device Tag in the filter bar to see the chart",
  "within": "within",
  "number-of-missions": "Number of missions",
  "missions": "Missions",
  "charts": "Charts",
  "first-name": "First name",
  "last-name": "Last name",
  "phone": "Phone",
  "mail": "Email",
  "password": "Password",
  "password-check": "Repeat password",
  "password-hint": "Min. 8 characters and at least: one uppercase letter, one lowercase letter and one number",
  "search": "Search...",
  "search-match": "{e} matches",
  "search-no-match": "{e} does not match",
  "search-no-devices": "No existing devices found for this search query.",
  "search-no-parts": "No existing parts found for this search query.",
  "search-no-cases": "No existing cases found for this search query. Create a new case and document the solution. This will help your colleagues to solve similar problems in the future.",
  "search-no-documents": "No documentation found. If you have documentation available, you can add it to the knowledge base and WAKU Care will suggest solutions from it, once it is indexed.",
  "search-result": "Search Result",
  "search-results": "Search Results",
  "type-to-search": "Type to search for {e} ...",
  "type-to-create": "Type to create new.",
  "search-in-knowledge-base": "Search in Knowledge Base...",
  "proposals-from-knowledge-base": "Proposals from Knowledge Base",
  "add-to-proposal": "Suggest this Solution",
  "results": "Results",
  "no-results-found": "No results found",
  "open": "Open",
  "all": "All",
  "done": "Complete",
  "logo": "Logo",
  "show": "Show",
  "hide": "Hide",
  "show-all": "Show All",
  "hide-all": "Hide All",
  "show-more": "Show More",
  "show-more-x": "Show More {e}",
  "format": "Format",
  "more": "More",
  "share": "Share",
  "shared": "Shared",
  "shift": "Shift",
  "exclude": "Exclude",
  "publish": "Publish",
  "published": "Published",
  "private": "Private",
  "approved": "Approved",
  "not-approved": "Not Approved",
  "documents-missing": "Missing Documents",
  "approver": "Approver",
  "executor": "Executor",
  "approver-source-user-description": "Choose a Workspace User as Approver",
  "approver-source-external-description": "Choose an Approver by Name and Email",
  "signature": "Signature",
  "approval-document": "Approval Document",
  "clear": "Clear",
  "clear-selection": "Clear Selection",
  "confirm": "Confirm",
  "delete": "Delete",
  "undo": "Undo",
  "decline": "Decline",
  "remove": "Remove",
  "accept": "Accept",
  "revoke": "Revoke",
  "revoke-of": "Revoke",
  "revoke-for": "Revoke",
  "status": "Status",
  "update-file": "Edit file",
  "update-file-information": "Edit file information",
  "download-file": "Download file",
  "general-information": "General Information",
  "additional-information": "Additional Information",
  "moved-to": "Moved to {e}",
  "changed-from": "{e} changed from",
  "was-changed": "{e} was changed",
  "was-updated": "{e} was changed",
  "was-created": "{e} was created",
  "was-added": "{e} was added",
  "was-deleted": "{e} was deleted",
  "was-removed": "{e} was removed",
  "was-assigned": "{e} was assigned",
  "from": "from",
  "to": "to",
  "deployment-share-code": {
    "description": "You receive this 6-digit Code from the Workspace of your partner, with whom you want to share your Deployment."
  },
  "workspace-share-code": {
    "title": "Share Code",
    "description": "This Code can be shared with trusted partners, if they intend to share a Deployment with your Workspace.",
    "warning": "Keep this Code secret at all times, to prevent abuse!"
  },
  "case-description": "Case Description",
  "case-proposal": "Solution Proposal",
  "case-solution": "Solution Statement",
  "case-solution-description": "Description of how the Case was resolved",
  "case-reported": "Case reported",
  "case-device": "Affected Device",
  "case-device-trigger": "Trigger",
  "case-device-trigger-help": "Displays device data that triggered this case.",
  "case-parts": "Affected Parts",
  "case-event-started": "Event Start Date",
  "case-event-finished": "Event End Date",
  "chart-create-case": "Create case from chart selection",
  "proposal-create-case": "Create case from this proposal",
  "case-event-help": "Optionally assign a start and/or end date to the case, if something happened in a specific time range or at a specific point in time.",
  "maintenance-linked-operations-empty": "For tracking issues encountered in this Work Order.",
  "maintenance-linked-service-jobs-empty": "For planning multiple Work Orders in a Service Job.",
  "event-log": "Event Log",
  "related-event-log": "Related Event Log",
  "set-deployment": "Set Deployment",
  "last-edited": "Last Changes",
  "last-maintenances": "Last Work Orders",
  "last-maintenance": "Last Work Order",
  "all-maintenance-strategies": "All strategies",
  "assigned-maintenance-strategies": "Assigned strategies",
  "automated-maintenance-strategy": "Automated Strategy",
  "maintenance-strategy-maintenances": "Strategy Work Orders",
  "performance": "Performance",
  "time": "Time",
  "current-time": "Current time",
  "timezone": "Timezone",
  "current-timezone": "Current timezone",
  "timezone-hint-user": "Current timezone you're operating in, affects display of date, time and notifications (eg. E-Mail).",
  "timezone-hint-deployment": "Timezone the Deployment is located in, affects display of date, time and notifications (eg. E-Mail).",
  "last-week": "Last week",
  "last-month": "Last month",
  "last-year": "Last year",
  "last-hour": "Last hour",
  "last-3-hours": "Last 3 hours",
  "last-6-hours": "Last 6 hours",
  "last-12-hours": "Last 12 hours",
  "last-24-hours": "Last 24 hours",
  "last-7-days": "Last 7 days",
  "last-14-days": "Last 14 days",
  "last-30-days": "Last 30 days",
  "last-90-days": "Last 90 days",
  "next-hour": "Next hour",
  "next-3-hours": "Next 3 hours",
  "next-6-hours": "Next 6 hours",
  "next-12-hours": "Next 12 hours",
  "next-24-hours": "Next 24 hours",
  "next-7-days": "Next 7 days",
  "next-14-days": "Next 14 days",
  "next-30-days": "Next 30 days",
  "next-90-days": "Next 90 days",
  "next-week": "Next week",
  "next-month": "Next month",
  "next-year": "Next year",
  "last-missions": "Last Missions",
  "last-errors": "Last Errors",
  "last-cases": "Last Cases",
  "last-device-logs": "Last Events",
  "severity": "Severity",
  "min-severity": "Min. Severity",
  "top-x": "Top {count}",
  "voice-input-beta": "Beta: experimental voice input",
  "unit": "Unit",
  "units": {
    "time": {
      "seconds": "seconds",
      "seconds.short": "sec."
    }
  },
  "datetime": {
    "today": "Today",
    "yesterday": "Yesterday",
    "inXdays": "in {daycount} days"
  },
  "schedule-by": {
    "date": "By Time",
    "usage": "By Usage",
    "incident": "By Anomalies"
  },
  "select-workspace": "Search Workspaces...",
  "select-interval": "Select interval",
  "select-days": "Select days",
  "select-date-range": "Select date range",
  "select-start-date": "Pick start-date",
  "select-finish-date": "Pick finish-date",
  "task-list": {
    "workspace-invitation": "{creator} invites you to join {name}.",
    "deployment-invitation": "{creator} invites you to join Deployment {name} in {workspace}."
  },
  "onboarding": {
    "title": "Welcome to WAKU Care!",
    "start": "Start Setup",
    "agreement": "I have read and agree to the WAKU Robotics {tos} and {tos-trial} and understand that my personal information is processed in accordance with the {pp}.",
    "tos": "Terms of Service",
    "pp": "Privacy Policy",
    "tos-trial": "Trial Terms of Service",
    "step": {
      "profile": {
        "title": "User Profile",
        "subtitle": "Personalize your account",
        "text": "What are your account details?"
      },
      "workspace-invitations": {
        "title": "Workspace Invitations",
        "subtitle": "Join a Workspace",
        "text": "Your Workspace Invitations"
      },
      "workspace": {
        "title": "Create Workspace",
        "subtitle": "Create a Workspace for your company",
        "description": "A workspace is your company’s central hub where all employees, settings, knowledge, and assets come together—making it easy to manage §, templates, files, tags, and configurations in one place.",
        "text": "Create a new Workspace",
        "label": "Workspace Name",
        "hint": "Note: Typically the company name (can be changed later)"
      },
      "trial": {
        "title": "Start Trial",
        "subtitle": "Get Started with intelligent Maintenance, Servicing & Operations",
        "text": "Try out all our powerful modules that provide features to improve your daily work. Grow your teams knowledge base and increase productivity by more than 3x.",
        "promo-maintenance": "Maintenance and Asset Management",
        "promo-parts": "Spare Part Management",
        "promo-machinedata": "IoT and Machine Data Connector",
        "promo-knowledge": "Intelligent Knowledge Management",
        "button": "Start with WAKU Care"
      }
    },
    "assistant": {
      "minimize": "Minimieren",
      "maximize": "Show More",
      "progress": "Your progress to get started",
      "title": "Lea-Marie",
      "text": "I’m Lea-Marie your WAKU Care assistant to get started with intelligent digital maintenance in a few minutes.",
      "banner-title": "WAKU Care Solution Experts",
      "banner-text": "Contact our experienced team to get professional support with onboarding, import, change management and more.",
      "banner-button": "Contact WAKU Care Support",
      "hide-permanently": "Don't show again",
      "section-1": {
        "title": "First setup steps",
        "step-1": "Create your personal account",
        "step-2": "Create company Workspace",
        "step-3": "Add your first Device"
      },
      "section-2": {
        "title": "Start with digital maintenance",
        "step-1": "Create a Work Order",
        "step-2": "Create a Work Template",
        "step-3": "Add preventive maintenance schedule"
      },
      "section-3": {
        "title": "Explore intelligent troubleshooting",
        "step-1": "Create a Case",
        "step-2": "Try intelligent Case solution suggestions",
        "step-3": "Link a Work Order to a Case"
      },
      "section-4": {
        "title": "Roll out to your team",
        "step-1": "Invite your team members",
        "step-2": "Reach out to WAKU Experts for support"
      }
    }
  },
  "registration": {
    "product-promo-pretitle": "Software for Maintenance and Service Teams",
    "product-promo-title-1": "Double Maintenance Efficiency.",
    "product-promo-title-2": "Manage knowledge. Avoid chaos.",
    "product-promo-chips": {
      "1": "Ready-To-Use AI Application",
      "2": "Digital & Mobile",
      "3": "Secure Data"
    },
    "product-promo-description": "Standardized, reliable maintenance and operation processes. AI driven, cloud powered and collaborative within your team, with partners and customers.",
    "product-promo-list-item-1": "Increases productivity and asset availability (OEE) significantly",
    "product-promo-list-item-2": "Secures valuable knowledge within the team",
    "product-promo-list-item-3": "Extends the lifetime of expensive machines",
    "product-promo-list-item-4": "Reduces costs and effort for spare parts",
    "product-promo-list-item-5": "Improves cost efficiency in the team",
    "learn-more": "Learn more",
    "no-credit-card": "No credit card required",
    "cancel": "Cancel any time",
    "have-an-account": "Already have an account?",
    "free-trial-title": "Focus on the essentials thanks to intelligent software for maintenance and operation of machines",
    "free-trial-cta": "Explore now",
    "free-trial-carousel-slogan-assistant": "Help, my machine is down!",
    "free-trial-carousel-slogan-eam": "Quick and secure instead of Excel and paper.",
    "free-trial-carousel-slogan-parts": "No more stress with spare parts!",
    "free-trial-carousel-slogan-service-teams": "Finally a 5-star customer service!",
    "free-trial-join-other-successful-companies": "Join other successful companies",
    "free-trial-addon-intelligence": "AI Assistant & Knowledge Management",
    "free-trial-module-maintenance": "Machines, Failures & Maintenance",
    "free-trial-module-parts": "Spare Parts & Inventory Management",
    "free-trial-module-data": "Machine Data & Reporting"
  },
  "trial": {
    "banner": "Trial ends in {days}d",
    "button": "Upgrade plan",
    "title": "Your free trial has ended",
    "subtitle": "Continue to be successful with WAKU Care",
    "contact": "Reach out to our sales team and get a custom offer to continue using WAKU Care.",
    "pricing-title": "WAKU Care packages with standard pricing model"
  },
  "offers": {
    "title": "Upgrade and activate the full power of WAKU Care for your team",
    "subtitle": "Flexibly chose one or more modules and add-ons based on your needs. You can add additional functions at any time to grow with your needs",
    "reach-out": "Reach out to our sales team and get a custom offer to continue using WAKU Care.",
    "request-offer-sent": "Your request for an offer has been sent. Our sales team will contact you shortly.",
    "more-pricing": "For more details on pricing plans, please schedule an appointment with our sales specialist, contact our sales team directly or visit our website.",
    "button-request-offer": "Request offer",
    "button-extend-trial": "Extend trial",
    "button-show-pricing": "Show pricing plans",
    "button-contact-sales": "Contact sales team",
    "pricing": {
      "from": "Starting at",
      "per-user-per-month": "per user / per month",
      "per-device-per-month": "per device / per month",
      "per-month": "per month"
    },
    "maintenance": {
      "pretitle": "CMMS & EAM",
      "title": "Intelligent maintenance\nand asset management",
      "price": "40"
    },
    "parts": {
      "pretitle": "GSPM",
      "title": "Spare Part Management",
      "price": "70"
    },
    "machinedata": {
      "title": "Machine & IoT\nData Insights",
      "price": "50"
    },
    "knowledge": {
      "title": "AI enabled Knowledge Management, Suggestions & Predictions",
      "text": "Increase the efficiency and quality of your maintenance and operations through intelligent knowledge management, smart solution suggestions, prediction and diagnostic functions",
      "price": "20"
    },
    "service-support": {
      "pretitle": "For service teams and technicians",
      "title": "Intelligent Service & Support Software Platform",
      "text": "Offer your customers fast and cost-efficient service thanks to WAKU Care with additional enterprise features. Give your customers access to a central and intelligent maintenance console and get an overview of all devices, spare parts and occurring problems.",
      "price": "150",
      "device-license": "Device License",
      "base-license": "Base License",
      "custom-offer": "Custom Offer"
    }
  },
  "business-type": {
    "title": "Your type of business",
    "device_user": {
      "title": "Device User",
      "description": "Your company is using the devices"
    },
    "service_provider": {
      "title": "Service Provider",
      "description": "Your company is operating or servicing devices of other companies"
    },
    "manufacturer": {
      "title": "Manufacturer",
      "description": "Your company is manufacturing (and servicing) devices"
    }
  },
  "academy": {
    "pretitle": "WAKU Care Academy",
    "title": "Help - Setup and usage of WAKU Care",
    "devices": {
      "title": "Manage your devices and assets with digital record files",
      "description": "Add your devices to WAKU Care to benefit from a digital record file for the whole lifetime of the device.\nWithin the record file all meta data, hardware details, maintenances, incidents, repairs, spare parts and ownership information will be stored as a complete and interactive history."
    },
    "deployments": {
      "title": "Organize your devices in deployments (Sites or Installations)",
      "description": "Deployments are used to group, locate and manage user access to devices.\nDeployments are typically representing a site or an installation. Every device can belong to only one deployment. Your own team members and external users can be assigned to deployments to allow secure and fine grained data access."
    },
    "templates": {
      "title": "Define and share Standard Operating Procedures (SOPs) with Templates",
      "description": "Templates help you define and standardize work procedures and share knowledge within your team and with partners.\nCreate reusable templates for maintenance routines, safety checks, cleaning procedures and more to ensure consistent quality and efficient execution. Share templates with team members or make them available to your service partners to establish best practices across organizations."
    },
    "cases": {
      "title": "Capture anomalies and incidents as Cases (Ticketing)",
      "description": "Cases are capturing anomalies and incidents during the operations and are typically created by the robot operators on-site. The solution suggestion and final solution are mostly provided by either in-house technicians or your service partner or manufacturer."
    },
    "workorders": {
      "title": "Guided work orders for multiple use cases",
      "description": "Document every work which was done to the devices no matter if it is regular cleaning rhythm, a scheduled maintenance, some reactive troubleshooting or the documentation of the installation or safety checks. All work orders are non editable and stored for ever as soon as marked \"Done\".",
      "description-continued": "Work orders provide a broad range of functions to react fast, avoid errors during work, reliable and secure documentation as well as analytical insights to find optimization potentials within the process.",
      "maintenance": "Maintenance",
      "cleaning": "Cleaning",
      "repairs": "Repairs",
      "troubleshooting": "Troubleshooting",
      "installation": "Installation",
      "safety": "Safety Checks",
      "checklists": "Work Templates",
      "approval": "Approval"
    },
    "strategies": {
      "title": "Maintenance and Service Strategies",
      "description": "Effective maintenance strategies are crucial for maximizing device reliability and lifetime. By implementing a combination of scheduled, usage-based and anomaly-based maintenance routines, you can prevent unexpected failures, optimally allocate resources and maintain consistent asset performance.",
      "scheduled": {
        "title": "Scheduled Maintenance",
        "description": "Regular, time-based maintenance activities performed at fixed intervals to prevent wear and ensure device reliability."
      },
      "usage": {
        "title": "Usage-Based Maintenance",
        "description": "Maintenance activities based on actual device usage to prevent wear and ensure device reliability."
      },
      "anomaly": {
        "title": "Anomaly-Based Maintenance",
        "description": "Proactive maintenance measures based on detected anomalies or unusual patterns to prevent potential failures."
      }
    },
    "inventory": {
      "title": "Manage your spare parts and components",
      "description": "Add your spare parts and components to WAKU Care and benefit from the digital record file over the entire lifecycle of the spare part."
    }
  },
  "checklist-templates-private": {
    "title": "Private",
    "description": "Your own crafted Work Templates"
  },
  "checklist-templates-shared": {
    "title": "Shared",
    "description": "Shared Work Templates by partners"
  },
  "checklist-templates-public": {
    "title": "Public",
    "description": "Public Work Templates by partners & OEMs"
  },
  "device-model-type": {
    "title": "Device Model Type",
    "stationary": "Stationary Device",
    "autonomous_vehicle": "Mobile Device",
    "manual_vehicle": "Manual Device",
    "human": "Human"
  },
  "device-model-file": {
    "share-with-children": "Automatically share file(s) with Customer Workspaces",
    "upload-help": "Name, description and locale of the files can be changed later, after upload.",
    "processing-status": "Processing status",
    "processing": "Processing",
    "processing-description": "Your file is being processed to make its contents available for search. This may take up to 24 hours.",
    "available-for-search": "Processed",
    "available-for-search-description": "Your file is processed and its contents are available for search and automatic suggestion in cases and maintenances."
  },
  "maintenance-strategy-trigger-type": {
    "type": "Trigger type",
    "observation-timeframe": "Within the last",
    "metric": "Metric"
  },
  "workspace-profile-update": {
    "publish": "Save & publish Profile",
    "edit": "Edit Workspace Profile",
    "public": "Your Workspace Profile is publicly visible on WAKU Care.",
    "private": "Your Workspace Profile is not publicly visible on WAKU Care.",
    "preview-subtitle": "How other WAKU Care users see your public Workspace Profile"
  },
  "workspace-create": {
    "title": "For integrators & resellers:",
    "text": "You can create workspaces for your clients and oversee them.",
    "hint-business-type": "Service Providers and Manufacturers gain additional Workspace management settings.",
    "hint-name": "This is the displayed name, additional information like 'GmbH' or 'UG' can be omitted.",
    "hint-abbreviation": "This is the abbreviation of the Workspace name, used for Case and Work Order IDs (eg. 'ABC-123').",
    "hint-abbreviation-warning": "WARNING! The abbreviation cannot be changed after creation of the Workspace!",
    "hint-deployment-name": "Name of your first Deployment in the new Workspace."
  },
  "workspace-delete": {
    "title": "Note, that you can only delete workspaces under the following conditions:",
    "item-1": "No started work orders",
    "item-2": "No open cases",
    "item-3": "No devices"
  },
  "deployment-delete": {
    "title": "Note, that you can only delete deployments under the following conditions:",
    "item-1": "No started work orders",
    "item-2": "No open cases",
    "item-3": "No devices"
  },
  "device-delete": {
    "title": "If you delete this device, it will be removed from:",
    "item-1": "All open Work Orders",
    "item-2": "All open Cases",
    "item-3": "All Work Order Strategies",
    "item-4": "All Device Tags",
    "item-5": "Connection Data"
  },
  "maintenance-tag-delete": {
    "title": "Note, that if you delete a Work Order Tag, it will be removed from all Work Orders assigned before."
  },
  "case-tag-delete": {
    "title": "Note, that if you delete a Work Order Tag, it will be removed from all Work Orders assigned before."
  },
  "device-tag-delete": {
    "title": "Note, that if you delete a Device Tag, it will be removed from all Devices assigned before. Also, all Device Tags which belong to this one will be deleted."
  },
  "device-tags-select": "{c} Device Tags selected",
  "device-tags-filter": "Filter by Device Tags",
  "mail-success": {
    "register": "Please check your email inbox to confirm and complete your registration!",
    "forgot-password": "Please check your email inbox to set your new password!"
  },
  "tooltip": {
    "checklist-template": {
      "public": "This is a public Work Template.",
      "shared": "This is a shared Work Template."
    }
  },
  "records-per-page": "Records per page",
  "empty-x": "No {e}",
  "empty": {
    "data": "There is no data yet.",
    "data-subtitle": "Add some data first, to see this table filled with detailed information.",
    "address": "No address stored",
    "description": "No description found.",
    "date": "No date found.",
    "notes": "No notes found.",
    "device": "No Device",
    "type": "No Type",
    "checklist-template": "No Work Template",
    "checklist-templates": "No Work Templates yet",
    "checklist-template-items": "No Tasks yet.",
    "maintenances": "No Work Orders",
    "maintenance-strategies": "No Strategies",
    "maintenance-notes": "No notes exist for this Work Order",
    "maintenance-devices": "Please add at least one device to the Work Order to start it",
    "maintenance-tag": "No Work Order Tag assigned",
    "files": "No documents yet.",
    "multimedia-files": "No multimedia files yet.",
    "cases": "No Cases yet.",
    "case-tag": "No Case Tag assigned",
    "strategy-interval": "No interval selected & saved",
    "select-results": "No results found.",
    "combobox-results": "No results matching \"{search}\". Press ENTER to create."
  },
  "verify": {
    "token-malformed": "The link you have used is expired and/or malformed. Please reset your password to proceed.",
    "complete": "Your account verification was successful!",
    "complete-title": "Account Verification",
    "complete-button": "Set Account Password",
    "invite": {
      "title": "Account Verification",
      "text": "Verify your account to get started with WAKU Care.",
      "button": "Verify Account"
    },
    "signup": {
      "title": "Account Verification",
      "text": "Verify your account to get started with WAKU Care.",
      "button": "Verify Account"
    },
    "recovery": {
      "title": "Password Recovery",
      "text": "Set your new password to be able to use WAKU Care.",
      "button": "Set New Password"
    }
  },
  "dialog": {
    "add": "Add {e}",
    "add-from": "Add {e} from {s}",
    "add-to": "Add {e} to {s}",
    "edit": "Edit {e}",
    "update": "Update {e}",
    "invite": "Invite {e}",
    "invite-to": "Invite {e} to {s}",
    "share": "Share {e}",
    "link": "Link {e}",
    "confirm": {
      "title": "Confirm {e}",
      "text": "Do you really want to {e}?\n This action cannot be undone!"
    },
    "delete": {
      "title": "Delete {e}",
      "text": "Do you really want to delete {e}?\n This action cannot be undone!"
    },
    "remove": {
      "title": "Remove {e}",
      "text": "Are you sure you want to remove {e}?\n This action cannot be undone!"
    },
    "publish": {
      "title": "Publish {e}",
      "text": "Are you sure you want to publish {e}?\n This action cannot be undone!"
    },
    "accept": {
      "title": "Accept {e}",
      "text": "Are you sure you want to accept {e}?"
    },
    "decline": {
      "title": "Reject {e}",
      "text": "Are you sure you want to reject {e}?\n This action cannot be undone!"
    },
    "undo": {
      "title": "Undo {e}",
      "text": "Are you sure you want to undo {e}?\n This action cannot be undone!"
    },
    "checklist-template": {
      "share": {
        "title": "Share Work Template",
        "text-share": "By sharing the Work Template, chosen WAKU Care workspaces can use it. The Work Template can not be found on the internet by humans or search engines.",
        "text-share-warning": "After sharing, the Work Template cannot be deleted. This action cannot be undone! "
      },
      "publish": {
        "title": "Publish Work Template",
        "text-publish": "By publishing the Work Template, all WAKU Care users can use it. The Work Template can not be found on the internet by humans or search engines.",
        "text-publish-warning": "After publishing, the Work Template cannot be deleted. This action cannot be undone! "
      }
    },
    "maintenance-strategy": {
      "devices": {
        "title": "Which Devices should be maintained?",
        "button-add": "Add Devices",
        "button-remove": "Remove {count} Devices"
      },
      "checklist-template": {
        "title": "Which Work Template should be assigned?",
        "button": "Set Work Template for {count} Devices"
      }
    },
    "maintenance": {
      "devices": {
        "title": "Which Devices should be maintained?",
        "button-add": "Add Devices",
        "button-remove": "Remove {count} Devices"
      },
      "checklist-template": {
        "title": "Which Work Template should be assigned?",
        "button": "Set Work Template for {count} Devices"
      },
      "task": {
        "create": {
          "title": "Add Tasks",
          "label": "What's planned to be done?"
        }
      },
      "start": {
        "title": "Take over Work Order",
        "assure-resources": "Make sure all relevant devices to be maintained and respective tasks are added to the Work Order before starting it.",
        "user-change": "You're currently not assigned to this Work Order. By starting it, you'll be assigned as responsible automatically."
      },
      "skip": {
        "title": "Skip Work Order",
        "text": "Please specify a reason, why this Work Order is to be skipped.",
        "user-change": "You're currently not assigned to this Work Order. Do you want to be assigned as responsible?"
      },
      "finish": {
        "title": "Finish Work Order",
        "text-unfinished": "Not all Work Order tasks are completed or skipped. In order to finish this Work Order, please finish or skip all Work Order tasks!",
        "text-finished": "Make sure you either checked or skipped all tasks of all devices! Once this Work Order routine is finished, you can't re-open it.",
        "user-change": "You're currently not assigned to this Work Order. Do you want to be assigned as responsible?",
        "resolve-case": "Do you want to resolve the Case, by which this Work Order was created?",
        "text-leftover-parts": "There are still parts left in this Work Order. Don't forget to move them back to the inventory after finishing the Work Order! You can do this from the Work Order detail page or the picking page.",
        "update-device-data-trigger": "Device Data Trigger \"{e}\""
      }
    },
    "workspace-profile": {
      "publish": {
        "title": "Update Workspace Profile",
        "text": "By publishing the Public Workspace Profile, all WAKU Care users can see your contact information. This action is irreversible. Are you sure?"
      }
    },
    "device-log": {
      "create": {
        "title": "Add Event Log Entry",
        "label": "What's planned to be done?"
      },
      "update": {
        "title": "Update Event Log Entry",
        "label": "What's planned to be done?"
      }
    },
    "case": {
      "create": {
        "title": "Add Case",
        "label": "Title (short problem summary)"
      },
      "use": {
        "title": "Use Case"
      },
      "create-as": {
        "title": "Create as Case"
      },
      "solve": {
        "title": "Solve",
        "text": "Provide a solution statement to resolve this Case."
      }
    },
    "device": {
      "move": {
        "title": "Change Device Deployment",
        "text": "This action removes the Device from all Strategies of the current Deployment and prevents access to the device for all users without access rights to the target Deployment"
      }
    },
    "part": {
      "delete": {
        "title": "All accounting data and historical data is irrevocably deleted! \n The transaction is NOT recorded as a write-off or withdrawal and cannot be viewed retroactively in the history."
      }
    }
  },
  "notify": {
    "error-reason": {
      "unexpected": "An unexpected error occurred, please try again.",
      "check-input": "Please check your input and try again.",
      "workspace-profile": "The profile of your workspace has to be published first.",
      "workspace-delete": "Workspaces can only be deleted if their deployments do not contain any devices, started workorders, or open cases.",
      "deployment-delete": "Deployments can only be deleted if they do not contain any devices, started workorders, or open cases.",
      "maintenance-strategy-deployment-change": "The deployment can only be changed while no devices are assigned to the maintenance strategy.",
      "duplicate-part": "Part exists already.",
      "part-location-no-template": "Part location cannot be nested further.",
      "part-inventory-undo-WC001": "Operation cannot be undone because another part depends on it. Delete the other part first.",
      "part-inventory-undo-WC002": "Operation cannot be undone from the target part. Delete this part and undo from the source part instead.",
      "part-inventory-undo-WC003": "This is not the most recent inventory entry. You can only undo the most recent inventory entry.",
      "auth": {
        "same_password": "New password should be different from the old password.",
        "weak_password": "Password should be at least 8 characters. Password should contain at least one lowercase, uppercase and digital character."
      }
    },
    "login": {
      "success": "Logged in successfully.",
      "error": "Error logging in. Please check your input and try again."
    },
    "logout": {
      "success": "Logged out successfully.",
      "error": "Error logging out."
    },
    "register": {
      "success": "Registered successfully.",
      "error": "Error registering."
    },
    "forgot-password": {
      "success": "Password reset mail sent successfully.",
      "error": "Error requesting password reset mail."
    },
    "get": {
      "success": "{e} fetched successfully.",
      "error": "{e} couldn't be fetched."
    },
    "create": {
      "success": "{e} created successfully.",
      "error": "{e} couldn't be created."
    },
    "update": {
      "success": "{e} saved successfully.",
      "error": "Changes to {e} couldn't be saved."
    },
    "delete": {
      "success": "{e} deleted successfully.",
      "error": "{e} couldn't be deleted."
    },
    "undo": {
      "success": "{e} successfully reverted.",
      "error": "{e} couldn't be reverted."
    },
    "remove": {
      "success": "{e} removed successfully.",
      "error": "{e} couldn't be removed."
    },
    "add": {
      "success": "{e} added successfully.",
      "error": "{e} couldn't be added."
    },
    "share": {
      "success": "{e} shared successfully.",
      "error": "{e} couldn't be shared."
    },
    "unshare": {
      "success": "Access to {e} revoked successfully.",
      "error": "Access to {e} couldn't be revoked."
    },
    "start": {
      "success": "{e} started successfully.",
      "error": "{e} couldn't be started."
    },
    "skip": {
      "success": "{e} skipped successfully.",
      "error": "{e} couldn't be skipped."
    },
    "finish": {
      "success": "{e} completed successfully.",
      "error": "{e} couldn't be completed."
    },
    "accept": {
      "success": "{e} accepted successfully.",
      "error": "{e} couldn't be accepted."
    },
    "decline": {
      "success": "{e} rejected successfully.",
      "error": "{e} couldn't be rejected."
    },
    "file-upload": {
      "success": "File(s) successfully uploaded.",
      "error": "File(s) couldn't be uploaded."
    },
    "file-download": {
      "success": "File(s) successfully downloaded.",
      "error": "File(s) couldn't be downloaded."
    },
    "file-delete": {
      "success": "File(s) successfully deleted.",
      "error": "File(s) couldn't be deleted."
    },
    "publish": {
      "success": "{e} published successfully.",
      "error": "{e} couldn't be published."
    },
    "export": {
      "success": "{e} exported successfully.",
      "error": "{e} couldn't be exported."
    }
  },
  "case-insights-charts": {
    "percentile": "p{p}",
    "throughput": {
      "title": "Throughput",
      "subtitle": "How many Cases were resolved per period"
    },
    "lead-time": {
      "title": "Lead Time",
      "subtitle": "Time from reporting a Case to resolving it (p50/p85/p95), by resolution date"
    },
    "cycle-time": {
      "title": "Cycle Time",
      "subtitle": "Time from starting a Case to resolving it (p50/p85/p95), by resolution date. Includes rework, since it is measured from the first start"
    },
    "time-in-status": {
      "title": "Time in Status",
      "subtitle": "How long Cases dwell in each status (p50/p85/p95). Cases still in their current status are included, clipped to the selected period"
    },
    "time-to-first-assignment": {
      "title": "Time to First Assignment",
      "subtitle": "Time from reporting a Case until it was first assigned to someone (p50/p85/p95)"
    }
  },
  "hours-short": "h",
  "minutes-short": "min",
  "days-short": "d"
}
